import Modal from 'bootstrap.native/src/components-v4/modal-native';
import Tooltip from "bootstrap.native/src/components-v4/tooltip-native";

import { setCookie, getCookie } from "@weseus/cms-core/assets/js/helpers";

import { createApp, ref } from 'vue';
import Bidding from "./bidding/bidding.vue";
import Wampy from "../wampy";

document.addEventListener("DOMContentLoaded", function (event) {

	initVanillaBidding(document);

	const biddingEl = document.getElementById('v_bidding');

	// Use Vue component
	if (biddingEl) {
		let biddingApp = null;
		const vanillaBackup = biddingEl.cloneNode(true);

		const topic = 'auction/bidding' + window.location.pathname;

		try {
			const user = ref({
				customer: {
					id: null,
					name: null,
					tariff: null,
					phoneVerified: false,
					urlProfile: null,
					walletBalance: null,
				},
				isBidder: false,
				isWinner: false,
				userMaximum: null,
				unfinishedAuctions: null,
			});

			const auction = ref({
				name: null,
				url: null,
				isPremium: false,
				lastFiveMinutes: false,
				auctionEnded: false,
				biddersCount: false,
				currentBidMoney: false,
				currentMinBidMoney: null,
				initBidMoney: null,
				paymentFeePercent: null,
				paymentFeeFixed: null,
				winner: {
					id: null,
					name: null,
					urlProfile: null,
				},
				bids: [],
			});

			const seller = ref({
				id: null,
				name: null,
				urlProfile: null,
				isPremium: false,
			});

			const flashMessages = ref([]);

			const wampy = new Wampy('', [], {
				autoReconnect: true,
				maxRetries: 5,
				onOpen: function () {
					if (getCookie('debug') !== null) {
						console.log('WAMP connected');
					}

					wampy.subscribe(topic, (json) => {
						const data = JSON.parse(json);

						if (getCookie('debug') !== null) {
							console.log('subscribed: ', data);
						}

						if (data.user !== undefined) {
							user.value = data.user;
						}

						if (data.auction !== undefined) {
							auction.value = data.auction;

							if (data.auction.winner !== null && user.value.customer !== null) {
								user.value.isWinner = data.auction.winner.id === user.value.customer.id;
							}
						}

						if (data.seller !== undefined) {
							seller.value = data.seller;
						}

						if (data.flashMessage !== undefined) {
							flashMessages.value.push(data.flashMessage);
						}

						if (biddingApp === null) {
							if (getCookie('debug') !== null) {
								console.log('Loading Vue bidding');
							}

							biddingApp = createApp(Bidding, {
								auction,
								user,
								seller,
								flashMessages,
								sendBid: (data) => {
									wampy.publish(topic, JSON.stringify(data));
								},
							});
							biddingApp.mount('#v_bidding');
						}
					});
				},
				onError: function (e) {
					if (getCookie('debug') !== null) {
						console.error('WAMP error: ', e);
					}
				},
				onClose: function () {
					if (getCookie('debug') !== null) {
						console.log('WAMP closed');
					}
					loadFallback();
				}
			});
		} catch (e) {
			if (getCookie('debug') !== null) {
				console.error(e);
			}

			loadFallback();
		}

		function loadFallback() {
			if (biddingApp !== null) {
				confirm('Selhalo spojení se systémem pro přihazovaní. Chcete obnovit stránku?') && location.reload();
			}

			if (getCookie('debug') !== null) {
				console.log('Loading vanilla bidding');
			}

			biddingEl.innerHTML = '';
			biddingEl.appendChild(vanillaBackup);
			initVanillaBidding(vanillaBackup);
		}
	}
});

function initVanillaBidding(block) {
	const minus = block.querySelector('#fn_minus');
	const plus = block.querySelector('#fn_plus');

	if (minus === null || plus === null) {
		return;
	}

	const input = minus.parentElement.querySelector('[name=money]');

	if (input === null) {
		return;
	}

	minus.addEventListener('click', (e) => {
		e.preventDefault();
		if (input.hasAttribute('min') && parseInt(input.getAttribute('min')) >= parseInt(input.value)) {
			return;
		}
		input.value = parseInt(input.value) - 1;
	});

	plus.addEventListener('click', (e) => {
		e.preventDefault();
		if (input.hasAttribute('max') && parseInt(input.getAttribute('max')) <= parseInt(input.value)) {
			return;
		}
		input.value = parseInt(input.value) + 1;
	});

	// Bid confirmation
	const bidButton = block.querySelector('#fn_bid_button');
	if (bidButton) {
		bidButton.addEventListener('click', (e) => {
			const moneyInput = bidButton.form.money;

			// ----- Nonpayer ------------------------------------------------------------------------------------------
			if (bidButton.hasAttribute('data-nonpayer')) {
				const rechargeBtn = block.querySelector('#fn_unfinished_auction-recharge')
				const paymentFeePercent = parseFloat(rechargeBtn.getAttribute('data-payment-fee-percent'));
				const paymentFeeFixed = parseFloat(rechargeBtn.getAttribute('data-payment-fee-fixed'));
				const paymentFee = parseFloat(moneyInput.value) * (paymentFeePercent / 100) + paymentFeeFixed;
				const walletBalance = parseFloat(rechargeBtn.getAttribute('data-wallet-balance'));
				const moneyToRecharge = Math.round(parseFloat(moneyInput.value) + paymentFee) - walletBalance;

				if (moneyToRecharge > 0) {
					e.preventDefault();

					rechargeBtn.href = rechargeBtn.href.replace('__amount__', moneyToRecharge);

					const money = block.querySelector('#fn_unfinished_auction-money')
					money.innerText = moneyToRecharge + ' ' + moneyInput.labels[0].innerText;

					const uaModalEl = block.querySelector('#fn_unfinished_auction-modal');
					const uaModal = uaModalEl.Modal || new Modal(uaModalEl);
					uaModal.show();

					return;
				}
			}

			// ----- Confirmation --------------------------------------------------------------------------------------
			const cookieName = 'bid_confirmation-' + window.location.pathname.substring(1);
			if (getCookie(cookieName) === '1') {
				return;
			}

			e.preventDefault();

			const money = block.querySelector('#fn_bid_confirmation-money')
			money.innerText = moneyInput.value + ' ' + moneyInput.labels[0].innerText;

			const confirmBtn = block.querySelector('#fn_bid_confirmation-confirm');
			confirmBtn.addEventListener('click', (e) => {
				e.preventDefault();

				const dismissCheckbox = block.querySelector('#fn_bid_confirmation-dismiss');
				if (dismissCheckbox.checked) {
					setCookie(cookieName, '1');
				}

				bidButton.form.submit();
			});

			const modalEl = block.querySelector('#fn_bid_confirmation-modal');
			const modal = modalEl.Modal || new Modal(modalEl);
			modal.show();
		});
	}

	// Init tooltips
	const dropdownElements = block.querySelectorAll('[data-toggle=tooltip]');
	dropdownElements.forEach((el) => {
		if (!el.Tooltip) {
			try {
				new Tooltip(el);
			} catch (e) {
				console.error("BSInitExtension", e);
			}
		}
	});
}